module.exports = __webpack_public_path__ + "static/media/alertadd.c9201fd9.svg";